import { useLoaderData, Await } from "react-router-dom"
import { Suspense } from "react"

import EditAccountMain from "../components/account/Edit"
import LoadingWrapperAuth from "../components/common/LoadingWrapperAuth"
import AccountWrapper from "../components/common/AccountWrapper"

const Edit = () => {
    const data = useLoaderData() 
     
    return <Suspense fallback={<LoadingWrapperAuth text=""/>}>
        <Await resolve={data.data}>
            {() => <>
                <AccountWrapper>
                    <EditAccountMain/>
                </AccountWrapper>
            </>}
        </Await>
    </Suspense>
}

export default Edit